// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

import Request from './request';


async function fetch(data) {
    return Request('get', "api/return-orders", data);
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/return-orders/" + id, data);
}

async function edit(data) {// 编辑退货单
    return Request('post', "api/return-orders/edit", data);
}

async function batchConfirm(data) {
    //批量确认
    return Request('get', 'api/return-orders/batch-confirm', data)
}

async function exports(data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('post', "api/return-orders/batch-out-detail-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function imports(file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/return-orders/import", data);
}

export default {
    fetch,
    fetchOne,
    batchConfirm,
    exports,
    imports,
    edit,
};